export const titles = {
    login: 'Log in - tute',
    register: 'Register - tute',
    dashboard: 'Dashboard - tute',
    timeline: 'Timeline - tute',
    lessons: 'Lessons - tute',
    messenger: 'Messages - tute',
    searchTutors: 'Search Tutors - tute',
    searchParents: 'Search Parents - tute',
    profile: 'Profile - tute',
    notFound: '404 - tute',
}
